import { EnhancedOrdersTable } from "@/features/orders/enhanced-orders-table";
import { CreateOrderDropdown } from "@/features/orders/create-order-dropdown";
import { useCenterScopeNotApplicable } from "@/contexts/carrier-scope-context";

const OrdersScreen = () => {
  // Orders are carrier-scoped at the shipment level, not center-scoped.
  // Disable the center picker while this screen is mounted.
  useCenterScopeNotApplicable();

  return (
    <div className="p-4">
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-2xl font-bold">Orders</h1>
        <CreateOrderDropdown />
      </div>
      <EnhancedOrdersTable />
    </div>
  );
};

export default OrdersScreen;
